import getCacheZeroQuery from '../actions/getCacheZeroQuery';
import getLiveZeroQuery from '../actions/getLiveZeroQuery';
import { isFeatureEnabled } from 'owa-feature-flags';
import shouldUse3SPeopleSuggestions from 'owa-recipient-suggestions/lib/util/shouldUse3SPeopleSuggestions';
import FindControlViewState from 'owa-recipient-types/lib/types/FindControlViewState';
import ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';

export default async function getZeroQueryResults(
    viewState: FindControlViewState,
    recipients: ReadWriteRecipientViewState[],
    scenario?: string
): Promise<void> {
    if (
        recipients?.length != 0 &&
        isFeatureEnabled('rp-contextualZeroQuery') &&
        shouldUse3SPeopleSuggestions()
    ) {
        await getLiveZeroQuery(viewState, recipients, scenario);
    } else {
        getCacheZeroQuery(viewState, recipients);
    }
}
